import React from 'react';

interface Props {
  id: string,
  checked: boolean,
  setChecked: (checked: boolean) => void,
  labelLeft?: string,
  labelRight?: string,
  labelLeftClass?: string,
  labelRightClass?: string,
  labelLeftTextClass?: string,
  labelRightTextClass?: string,
  containerClass?: string,
  toggleTextOn?: string,
  toggleTextOff?: string,
  toggleSliderClass?: string,
}

const DoubleLabeledGenericToggleSwitch: React.FC<Props> = ({
  id,
  checked,
  setChecked,
  labelLeft,
  labelRight,
  labelLeftClass,
  labelRightClass,
  labelLeftTextClass,
  labelRightTextClass,
  containerClass,
  toggleTextOn,
  toggleTextOff,
  toggleSliderClass,
}) => {
  return (
    <div className={`toggle-slider-container ${containerClass}`}>
      {!!labelLeft && (
        <label
          htmlFor={id}
          className={labelLeftClass || ''}
        >
          <span className={labelLeftTextClass || ''}>{labelLeft}</span>
        </label>
      )}
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label
        className="toggle-inner-container mb-0"
      >
        <input
          id={id}
          checked={checked}
          onChange={() => setChecked(!checked)}
          type="checkbox"
          className="toggle-slider-input"
        />
        <span className={`toggle-slider ${toggleSliderClass || ''}`}>
          {checked ? toggleTextOn : toggleTextOff}
        </span>
      </label>
      {!!labelRight && (
        <label
          htmlFor={id}
          className={labelRightClass || ''}
        >
          <span className={labelRightTextClass || ''}>{labelRight}</span>
        </label>
      )}
    </div>
  );
};

export default DoubleLabeledGenericToggleSwitch;
